import { render, staticRenderFns } from "./vueTasksGanttChart.vue?vue&type=template&id=cfa7d276&scoped=true&"
import script from "./vueTasksGanttChart.vue?vue&type=script&lang=js&"
export * from "./vueTasksGanttChart.vue?vue&type=script&lang=js&"
import style0 from "./vueTasksGanttChart.vue?vue&type=style&index=0&id=cfa7d276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa7d276",
  null
  
)

export default component.exports